import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider, StylesProvider, createGenerateClassName } from '@material-ui/core/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { HelmetProvider } from 'react-helmet-async';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Routes from './routes';
import theme from './theme';
import Layout from './components/Layout';
import { useAppApolloClient } from './config/apolloClient';
import { CalendarProvider } from "contexts/CalendarContext";
import ErrorBoundary from 'components/ErrorBoundary';
import AnalyticsListener from 'components/AnalyticsListener';
import DragLayer from 'components/DragLayer';
import ScrollingContainer from 'components/ScrollingContainer';
import { SearchProvider } from './contexts/SearchContext';

const generateClassName = createGenerateClassName();

function App() {
  const apolloClient = useAppApolloClient();

  return (
    <GoogleOAuthProvider clientId={import.meta.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
      <HelmetProvider>
        <ApolloProvider client={apolloClient}>
          <StylesProvider generateClassName={generateClassName} injectFirst>
            <ThemeProvider theme={theme}>
              <StyledThemeProvider theme={theme}>
                <AnalyticsListener>
                  <SearchProvider initialValue={''}>
                    <CalendarProvider>
                      <DndProvider backend={HTML5Backend} context={window}>
                        <DragLayer />
                        <Layout>
                          <ScrollingContainer>
                            <ErrorBoundary>
                              <Routes />
                            </ErrorBoundary>
                          </ScrollingContainer>
                        </Layout>
                      </DndProvider>
                    </CalendarProvider>
                  </SearchProvider>
                </AnalyticsListener>
              </StyledThemeProvider>
            </ThemeProvider>
          </StylesProvider>
        </ApolloProvider>
      </HelmetProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
